



























import { VueCustom, CustomVueConstructor } from 'vue-custom';
import { WorkspaceElement } from 'types';
import { mapGetters } from 'stores';

import { WORKSPACE_ID } from 'constants/drag';
import { TRANSITION_END } from 'constants/css';
import { ANIMATION_CLEAR, ANIMATION_REVERT } from 'constants/animations';
import { ANIMATION_CONFIGS } from 'constants/animation-config';
import EventsManager from 'managers/events.manager';

import FinalBox from './final-box.vue';
import WorkspaceBox from './box.vue';
import BoxSizing from './size.vue';

const ANIMATION_CONFIG = ANIMATION_CONFIGS[ANIMATION_CLEAR];

type ComponentCustom = {
  $refs: {
    element: HTMLDivElement,
  },
};
export default (VueCustom as CustomVueConstructor<ComponentCustom>).extend({
  name: 'workspace',
  components: {
    WorkspaceBox,
    FinalBox,
    BoxSizing,
  },
  data: () => ({
    listenerAdded: false,
  }),
  computed: {
    ...mapGetters([
      'workspaceElements',
      'workspaceRevertable',
      'workspaceFinal',
      'workspaceExhausted',
      'isAnimationActive',
      'animationFinalFinished',
      'droppableById',
    ]),
    WORKSPACE_ID() {
      return WORKSPACE_ID;
    },
    ifAnimateClear(): boolean {
      return this.isAnimationActive(ANIMATION_CLEAR) || this.workspaceRevertable;
    },
    ifAnimateRevert(): boolean {
      return this.isAnimationActive(ANIMATION_REVERT);
    },
    workspaceFinalWithoutAnimated(): WorkspaceElement[] {
      return this.workspaceFinal.filter(({ elementId }) =>
        !this.animationFinalFinished.includes(elementId));
    },
    workspaceExhaustedWithoutAnimated(): WorkspaceElement[] {
      return this.workspaceExhausted.filter(({ elementId }) =>
        !this.animationFinalFinished.includes(elementId));
    },
    classes(): Record<string, boolean> {
      return {
        'js-cleanup': this.ifAnimateClear || this.ifAnimateRevert,
        'js-revert': this.ifAnimateRevert,
      };
    },
  },
  mounted() {
    this.onTransitionEnd = this.onTransitionEnd.bind(this);
  },
  watch: {
    ifAnimateClear: 'addTransitionListener',
    ifAnimateRevert: 'addTransitionListener',
  },
  methods: {
    onLongpress({ target }: { target: HTMLElement }) {
      if (!target) return;

      const id = (target.parentNode as any).dataset.id;
      const droppable = this.droppableById(id);
      if (!droppable) return;

      EventsManager.emit('ENCYCLOPEDIA_SHOW_ITEM', droppable.elementId);
    },
    addTransitionListener(add: boolean) {
      if (!add || this.listenerAdded) return;

      this.$refs.element.addEventListener(TRANSITION_END, this.onTransitionEnd as any, false);
      this.listenerAdded = true;
    },
    onTransitionEnd({ target, propertyName: property }: TransitionEvent) {
      if (target !== this.$refs.element) return;

      const isMiddleRevert = property.includes(ANIMATION_CONFIG.revertMiddle) && this.ifAnimateRevert;
      const isMiddleClear = property.includes(ANIMATION_CONFIG.transitionMiddle) && this.ifAnimateClear;
      if (isMiddleRevert || isMiddleClear) {
        this.onWorkspaceAnimationMiddle();
        return;
      }

      this.onWorkspaceAnimationEnd();
    },
    onWorkspaceAnimationMiddle() {
      EventsManager.emit('ANIMATION_WORKSPACE_MIDDLE');
    },
    onWorkspaceAnimationEnd() {
      this.$store.dispatch('animationReset');
      this.$refs.element.removeEventListener(TRANSITION_END, this.onTransitionEnd as any);
      this.listenerAdded = false;
    },
  },
});
